// src/firebase/firebase.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeFirestore, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAia0y1uWzLBUCWBvq1wkPYmMlkgd_km6w",
  authDomain: "scriblish-a6407.firebaseapp.com",
  projectId: "scriblish-a6407",
  storageBucket: "scriblish-a6407.firebasestorage.app",
  messagingSenderId: "1036798802833",
  appId: "1:1036798802833:web:185b96f0bad3b8aa433830",
  measurementId: "G-DVGZ3Y0N47"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED
});

export const storage = getStorage(app);

export default app;

